import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_PAGE_SIZE = 20

export default defineStore('preferences', () => {
  const sapImportPageSize = ref(DEFAULT_PAGE_SIZE)
  const clientsPageSize = ref(DEFAULT_PAGE_SIZE)
  const workflowsPageSize = ref(DEFAULT_PAGE_SIZE)
  const deadLettersPageSize = ref(DEFAULT_PAGE_SIZE)
  
  const setSapImportPageSize = (size: number) => {
    sapImportPageSize.value = size
  }
  
  const setClientsPageSize = (size: number) => {
    clientsPageSize.value = size
  }
  
  const setWorkflowsPageSize = (size: number) => {
    workflowsPageSize.value = size
  }
  
  const setDeadLettersPageSize = (size: number) => {
    deadLettersPageSize.value = size
  }
  
  return {
    sapImportPageSize,
    clientsPageSize,
    workflowsPageSize,
    deadLettersPageSize,
    setSapImportPageSize,
    setClientsPageSize,
    setWorkflowsPageSize,
    setDeadLettersPageSize
  }
}, {
  persist: {
    key: 'preferences',
    storage: typeof window !== 'undefined' ? localStorage : undefined,
    pick: ['sapImportPageSize', 'clientsPageSize', 'workflowsPageSize', 'deadLettersPageSize']
  }
})
